export function debounce(func: Function, timeout: number = 300) {
  let timer: number;
  return (...args: any) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      func(...args);
    }, timeout) as unknown as number;
  };
}
